import {
  jb_lazy_loading_uploads_css_default
} from "./chunk.GWIIY2S2.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-lazy-loading-uploads/jb-lazy-loading-uploads.ts
var JbLazyLoadingUploads = class extends i {
  firstUpdated() {
    this._uploads = Array.from(this.querySelectorAll("jb-upload"));
    this._showFilledPlusOneEmpty();
  }
  _showFilledPlusOneEmpty() {
    this._uploads.forEach((upload) => {
      upload.style.display = "none";
    });
    this._uploads.filter((upload) => upload.isUploaded).forEach((upload) => {
      upload.style.display = "initial";
    });
    const firstEmptyField = this._uploads.filter((upload) => !upload.isUploaded).shift();
    if (firstEmptyField) {
      firstEmptyField.style.display = "initial";
    }
  }
  render() {
    return b`<section><slot @jb-upload:field-change=${this._showFilledPlusOneEmpty}></slot></section>`;
  }
};
JbLazyLoadingUploads.styles = [reset_css_default, jb_lazy_loading_uploads_css_default];
JbLazyLoadingUploads = __decorateClass([
  customElement("jb-lazy-loading-uploads")
], JbLazyLoadingUploads);

export {
  JbLazyLoadingUploads
};
